<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center" md="8" lg="8" xl="5">
                        <div class="font-weight-bold body-1">
                            Detalles de orden de compra
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="8" lg="8" xl="5" >

                    <details-item :detailsItems="items"></details-item>

                    <v-row justify="center" no-gutters>
                        <v-col class="my-0 py-0">
                            <div >
                                <v-row justify="center" align="center" no-gutters class="my-2">
                                    <v-col align-self="start"><span class="font-weight-bold normalText--text">Comentarios</span></v-col>
                                    <v-col class="text-right">
                                        <!-- <span class="normalText--text pre">vl</span>
                                            -->
                                            <v-btn color="transparent" depressed small @click="openGlobalComments()"><v-icon :color="colorCommentIcon">mdi-message-outline</v-icon></v-btn>
                                    </v-col>
                                    
                                    
                                </v-row>
                                <v-divider></v-divider>
                            </div>
                        </v-col>
                    </v-row>

                    </v-col>
                    
                </v-row>

                <!-- Comments -->
                <modal data-cy="index-modal" :props="modalCommentsProps" @modalResponse="method_handler">
                
                    <!-- Buttons -->
                    <template slot="cardBody">
                        <div v-if="localMessages.length == 0" class="text-center mx-auto">
                            <span  >
                                Aún no hay comentarios para la orden de compra {{id}}
                            </span>
                        </div>
                        <div v-for="(message, index) in localMessages" :key="index">
                            <div :class="`my-3 mx-2 ${message.position == 'right' ? 'text-right' : 'text-left'}`">
                                <p class="pb-0 mb-0 requisitions-comments-comment"  data-cy="comments-chat-text">{{message.comments}}</p>
                                <p class="pb-0 mb-0 requisitions-comments-user">{{message.user}} ({{message.date}})</p>
                            </div>
                        </div>
                    </template>
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-modal-actions">
                            <!-- <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-modal-btn"
                                :props="cancelCommentsModal"
                                ></secondaryButton>
                            </v-col> -->
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-modal-btn"
                                :props="acceptCommentsModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>

                <!-- PRODUCTS -->
                <v-row justify="center">
                    <v-col class="pt-3 pb-0 font-weight-bold body-2 mb-0" cols="12" md="8" lg="8" xl="5">
                        <p class="mb-0 pb-0">Insumos</p>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col class="pb-2 pt-0 mt-0" cols="12" md="8" lg="8" xl="5">
                        <table-items :props="tableProps" :items="products">
                            
                        <template v-slot:item.actions="item" >


                            <RequisitionTableActions
                                :itemInput="item.item"
                                :parameters="item.parameters"
                                :edit="true"
                                @methodHandler="method_handler"
                                :nudgeLeft="7"
                                :show="true"
                            ></RequisitionTableActions>
                         </template>
                            
                        </table-items>
                        
                    </v-col>
                </v-row>


                <!-- SUMMARY --> 
                <v-row justify="center">
                    <v-col class="pt-3 pb-0 font-weight-bold body-2 mb-0" cols="12" md="8" lg="8" xl="5">
                        <p class="mb-0 pb-0">RESUMEN ÓRDENES DE ENTRADA</p>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col class="pb-2 pt-0 mt-0" cols="12" md="8" lg="8" xl="5">
                        <table-items :props="tablePropsSummary" :items="summary">
                            
                           
                            
                        </table-items>
                        
                    </v-col>
                </v-row>

               
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="8" lg="8" xl="5" class="d-flex justify-end">
                    
					<primary-button data-cy="cancel-btn" :props="cancelBtnData"></primary-button>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import DetailsItem from '../../../components/DetailsItem.vue';
import Utils from '../../../helpers/Utils';
import RequisitionTableActions from '../requisitions/RequisitionTableActions.vue';
export default {
    components: {
        DetailsItem,
        RequisitionTableActions,
        
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
           
            items: [
               
                
            ],
            localMessages:[],
            colorCommentIcon: 'grey',

            products: [],
            summary:[],
            actions: [
				{
					name: 'Descripciones',
					icon: {
						color: 'secondary',
						icon: 'mdi-message-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openComments',
                    dataCy: "descriptions-link"
				},
			],
            tableProps: {
				headers: [
                     {
						text: 'Insumo',
						align: 'left break-words',
						value: 'name',
                        
						class: 'table-b-border black--text',
                        sortable: false,
					},
					
                    {
						text: 'Cantidad',
						align: 'center',
						value: 'quantity',
						sortable: false,
                        width: "18%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Importe',
						align: 'center',
						value: 'amount',
						sortable: false,
                        width: "18%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Subtotal',
						align: 'center',
						value: 'subtotal',
						sortable: false,
                        width: "18%",
						class: 'table-b-border black--text'
					},

                    {
						text: '',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '15%',
						class: 'table-b-border black--text'
					}
                   
					
				],
				items: [],
				search: '',
				loading: false
			},

            tablePropsSummary: {
				headers: [
                     {
						text: 'Insumo',
						align: 'left break-words',
						value: 'product',
                        
						class: 'table-b-border black--text',
                        sortable: false,
					},

                     {
						text: 'Fecha',
						align: 'center',
						value: 'date',
						sortable: false,
                        width: "15%",
						class: 'table-b-border black--text'
					},
					
                    {
						text: 'Cantidad',
						align: 'center',
						value: 'entry',
						sortable: false,
                        width: "10%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Pendiente',
						align: 'center',
						value: 'pending',
						sortable: false,
                        width: "10%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Excedente',
						align: 'center',
						value: 'surplus',
						sortable: false,
                        width: "10%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Total',
						align: 'center',
						value: 'total',
						sortable: false,
                        width: "10%",
						class: 'table-b-border black--text'
					},
                   
					
				],
				items: [],
				search: '',
				loading: false
			},
            modalCommentsProps: {
				visible: false,
				width: '600',
				title: 'Comentarios',
				text: '',
				loading: false,
				bottomLineColor: 'primary',
				scrollable:true
			},
            acceptCommentsModal: {
                text: "Cerrar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'black',
                textColorLevel: '0',
				loading:false,
                cy:"accept-modal-btn",
                click: ()=>{this.modalCommentsProps.visible = false}
            },
			
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "PurchaseOrders",	
                click: () => {}
            },
           
          
		}
    },
    mounted(){
        this.index();
    },
	methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
		validate () {
			return this.$refs.form.validate()
		},
        openGlobalComments()
        {
            this.modalCommentsProps.visible = true;
        },
       
        
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.purchaseOrder.show(this.id)
			.then((response) => {
                console.log(response);
                

                this.localMessages = response.data.data.comments??[];

                if(this.localMessages.length > 0)
                    this.colorCommentIcon = 'success';
               
                this.items= [
                    { concepto: 'Proveedor', index: 'sku', valor: response.data.data.supplier },
                    { concepto: 'Fecha', index: 'description', valor:response.data.data.date},
                    { concepto: 'Requisición', index: 'unit', valor: response.data.data.requisition_id??"" },
                    { concepto: 'Esta compra se paga a parcialidades', index: 'unit', valor: response.data.data.has_installments == 1 ? 'Si':'No' },
                    
                ];

                if(response.data.data.invoice != '' && response.data.data.invoice != null){
                    this.items.push(
                        // {concepto: 'Factura', index: 'quotation_file_url', valor: response.data.data.invoice, isFile:true}
                        //! remove when file is available
                        { concepto: 'Adjunto', index: 'slug', valor: '' },
                    );
                }else{
                    this.items.push(
                        { concepto: 'Factura', index: 'slug', valor: '' },
                    );
                }

                //products 
                this.products = response.data.supplies.map((x,i) => {
                    
                    x.subtotal = x.quantity * x.amount;
                    
                    x.subtotal = Utils.currencyFormat(x.subtotal, "");
                    x.amount = Utils.currencyFormat(x.amount, "");

                    x.actions =  JSON.parse(JSON.stringify(this.actions)),
                    x.parameters = { id: x.supply_id, name: x.supply, index: i},

                    x.localMessages=  [...x?.comments?.map((ms) => {return{...ms, isNew:false}})??[]],
                    x.comments = x.comments??''
                    
                    return x;
                });

                this.summary = response.data.summary;
                
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},

        openComments(){
            try {
                setTimeout(() => {
                    this.tobottom();
                }, 100);
            } catch (error) {
                console.log(error)
            }

            return true;
        },
        tobottom () {
            try {
                this.$refs.listChat[0].scrollTop = this.$refs.listChat[0].lastElementChild.offsetTop;
            } catch (error) {
                console.log(error);
            }
        },
       
    },
}
</script>

<style>
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }
</style> 